module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "desktop-subheader"
  }, [_c('div', {
    staticClass: "desktop-subheader__container mx-auto"
  }, [_c('div', {
    staticClass: "desktop-subheader-title"
  }, [_vm._v("\n      " + _vm._s(_vm.subheaderTitle) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "desktop-subheader-nav"
  }, [_vm._t("subheader-nav")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27d7fb1a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DesktopSubheader.vue
// module id = 1560
// module chunks = 1